const ITEMS = [
    "LIFT INSTALLATION",
    "MAINTENANCE & AMC",
    "BREAKDOWN SERVICE",
    "REPAIR & TROUBLESHOOTING",
    "MULTI-BRAND SUPPORT",
    "PATNA",
    "GAYA",
    "RANCHI",
];

export const Marquee = () => (
    <div
        data-testid="services-marquee"
        className="overflow-hidden border-y border-[#13274A] bg-[#0B1528] py-5"
        aria-hidden="true"
    >
        <div className="marquee-track flex w-max items-center">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="px-8 text-sm font-bold uppercase tracking-[0.35em] text-slate-400">
                        {item}
                    </span>
                    <span className="h-1.5 w-1.5 rounded-full bg-[#2563EB]" />
                </span>
            ))}
        </div>
    </div>
);
